import { render, staticRenderFns } from "./NodeSwitch.vue?vue&type=template&id=2cc119db&"
import script from "./NodeSwitch.vue?vue&type=script&lang=js&"
export * from "./NodeSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports